export default __webpack_public_path__ + "static/media/blur-sm.fc92ddb2.png";